import { createQueryHook } from '../internal/createQueryHook';
import { applications } from '../queries/applications';

/**
 * @deprecated Use `applications.detail()` with `useQuery` directly.
 */
export const useApplication = createQueryHook(({ applicationKey }: { applicationKey: string }) =>
  applications.detail({ applicationKey }),
);
